!function(e) {
    "use strict";
    e.Abstract = Class.extend({
        initialize: function() {
            this._eventListeners = {};
        },
        _callEventListeners: function(e, t) {
            var i = this._eventListeners[e];
            if (i) {
                var n = this;
                $.each(i, function() {
                    this.fnc.apply(this.ctx || n, t);
                });
            }
        },
        on: function(e, t, i) {
            if ("string" != typeof e) return void console.error("e must be a string");
            if ("function" != typeof t) return void console.error("fnc must be a function");
            e = e.split(".");
            var n = e[0], s = this._eventListeners[n];
            if (s) {
                var a = e[1];
                s.push({
                    ctx: i,
                    fnc: t,
                    id: a
                });
            }
            return this;
        },
        off: function(e) {
            var t = this._eventListeners;
            if (e) {
                e = e.split(".");
                var i = e[0], n = t[i];
                if (n) {
                    var s = e[1];
                    if (s) {
                        var a;
                        $.each(n, function(e) {
                            this.id === s && (a = e);
                        }), n.splice(a, 1);
                    } else t[i] = [];
                }
            } else $.each(t, function(e) {
                t[e] = [];
            });
            return this;
        },
        trigger: function(e) {
            var t = this[e];
            return "function" == typeof t && t.call(this), this;
        }
    });
}(window), function(e) {
    "use strict";
    e.App = Class.extend({
        initialize: function(e) {
            this.$elem = e, this.$nav = $("nav", e), this.$footer = $("footer", e), this.components = {}, 
            this.controllers = {}, this.loader = new components.Loader({
                $parent: $body
            });
        },
        activate: function() {
            var e = this;
            $("[data-controller]", this.$elem).each(function() {
                e.initController($(this));
            }), $("[data-component][data-init]", this.$elem).each(function() {
                e.initComponent($(this));
            }), wdw.trigger("resize"), "#dev" !== window.location.hash && TL.to($htmlBody, .001, {
                scrollTop: 0
            }), this.loader.hide(function() {
                TL.to(e.$elem, SPEED, {
                    opacity: 1
                });
            }), this.revealController = new controllers.RevealController($(".view"));
        },
        initComponent: function(e) {
            var t = components[utils.classify(e.data("component"))], i = t ? new t(e) : new Component(e);
            i.id && (this.components[i.id] = i);
        },
        initController: function(e) {
            var t = controllers[utils.classify(e.data("controller"))], i = t ? new t(e) : new Controller(e);
            this.controllers[i.id] = i;
        },
        onPanEnd: function(e) {
            $input.attr("disabled", !1), $body.removeClass("is-panning"), e.removeClass("is-panning");
        },
        onPanStart: function(e) {
            $body.addClass("is-panning"), $input.attr("disabled", !0), e.addClass("is-panning");
        }
    });
}(window), function(e) {
    "use strict";
    e.Component = Class.extend(Abstract, {
        initialize: function(e, t) {
            this.parent(), e && e.jquery || (e = $("<div></div>"), console.error("Component: invalid jQuery element."));
            var i = e.data() || {};
            t = $.extend(!0, {
                classes: ""
            }, this._defaultOptions, i.options, t), this.$elem = e, this.data = i, this.id = utils.camelize(i.id), 
            this.options = t, this.type = i.component, e.addClass(t.classes);
        }
    });
}(window), function(e) {
    "use strict";
    e.Controller = Class.extend({
        initialize: function(e) {
            this.$elem = e, this.id = e.data("controller");
        }
    });
}(window), function(e) {
    "use strict";
    e.Doc = Class.extend(Abstract, {
        initialize: function() {
            this.parent();
            var e = this;
            this.$elem = $document, this._queues = {
                enter: [],
                escape: []
            }, this._keyCodes = {
                13: "enter",
                27: "escape"
            }, this.$elem.on("keyup", function(t) {
                e._onKeyUp(t);
            });
        },
        _onKeyUp: function(e) {
            var t = this._queues[this._keyCodes[e.keyCode]];
            if (t) {
                var i = t[t.length - 1];
                i && (t.pop(), i.fnc.call(i.ctx));
            }
        },
        addToQueue: function(e, t, i) {
            var n = this._queues[e];
            if (n) {
                var s = {
                    fnc: t,
                    ctx: i
                };
                return n.push(s), n.indexOf(s);
            }
        },
        removeFromQueue: function(e, t) {
            var i = this._queues[e];
            i && i.splice(t, 1);
        }
    });
}(window), function(e) {
    "use strict";
    e.Wdw = Class.extend(Abstract, {
        initialize: function() {
            this.parent(), this.$elem = $window, this._rAF = null, this._resizeEventListenersActive = !1, 
            this._scrollEventListenersActive = !1, this._eventListeners = {
                resize: [],
                scroll: []
            }, this.width = null, this.height = null, this.scrollTop = null, this._setDimensions();
        },
        _addResizeEventListeners: function() {
            if (!this._resizeEventListenersActive) {
                this._resizeEventListenersActive = !0;
                var e = this;
                this.$elem.resize(function() {
                    e._didResize();
                });
            }
        },
        _removeResizeEventListeners: function() {
            this._resizeEventListenersActive && (this._resizeEventListenersActive = !1, this.$elem.unbind());
        },
        _addScrollEventListeners: function() {
            this._scrollEventListenersActive || (this._scrollEventListenersActive = !0, this._didScroll());
        },
        _removeScrollEventListeners: function() {
            this._scrollEventListenersActive && (this._scrollEventListenersActive = !1, cancelAnimationFrame(this._rAF));
        },
        _didResize: function() {
            this._setDimensions(), this._callEventListeners("resize", [ this.width, this.height ]);
        },
        _didScroll: function() {
            var e = this, t = $document.scrollTop();
            t !== this.scrollTop && (this.scrollTop = t, this._callEventListeners("scroll", [ t ])), 
            this._rAF = requestAnimationFrame = function (callback) {
        return setTimeout(callback, 1000 / 60);
               e._didScroll();
    };         
          
        },
        _setDimensions: function() {
            this.width = this.$elem.width(), this.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        },
        _toggleEventListeners: function() {
            this._eventListeners.resize.length ? this._addResizeEventListeners() : this._removeResizeEventListeners(), 
            this._eventListeners.scroll.length ? this._addScrollEventListeners() : this._removeScrollEventListeners();
        },
        on: function(e, t, i) {
            return this.parent(e, t, i), this._toggleEventListeners(), this;
        },
        off: function(e) {
            return this.parent(e), this._toggleEventListeners(), this;
        },
        resize: function() {
            return this.$elem.resize(), this;
        }
    });
}(window), function(e) {
    "use strict";
    e.$html = $("html"), e.$body = $("body"), e.$input = $("input"), e.$window = $(window), 
    e.$document = $(document), e.$htmlBody = e.$html.add($body), e.indicators = {}, 
    e.components = {}, e.controllers = {}, e.TL = TweenLite, e.SPEED = .2, e.MQ = {
        phablet: 850
    }, e.COLORS = {
        "type-1": "#6ba4b8",
        "type-2": "#72C9BA",
        "type-3": "#ffa300",
        "type-5": "#b2f418"
    };
}(window), function(e) {
    "use strict";
    e.templates = {
        image: [ '<div class="watch-{{type}}"><div class="modal-image-gallery-container" style="{{style}}"><img src="{{src}}" alt="{{alt}}" width="{{width}}" height="{{height}}"></div><a class="image-gallery-btn image-gallery-btn-prev image-gallery-modal-btn-prev icon-arrow-left"></a><a class="image-gallery-btn image-gallery-btn-next image-gallery-modal-btn-next icon-arrow-right"></a></div>' ],
        loader: [ '<div class="loader--container"><div class="loader"><div class="loader--content"></div></div></div>' ],
        modal: {
            box: [ '<div class="modal-box">{{content}}</div>' ],
            main: [ '<div class="modal">', '<div class="modal-centered">', '<div class="modal-centered-content">', '<div class="modal-content"></div>', "</div>", "</div>", '<div class="modal-btn-hide icon-cross"></div>', "</div>" ]
        },
        youtube: '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/{{id}}?autoplay=1&amp;rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>'
    };
}(window), function(e) {
    "use strict";
    e.utils = {
        breakpoint: function(e) {
            return e <= 460 ? "smallPhone" : e <= 740 ? "phone" : e <= 850 ? "phablet" : e <= 1020 ? "phabletBig" : e <= 1030 ? "tablet" : e <= 1300 ? "netbook" : e <= 1440 ? "laptop" : "desktop";
        },
        call: function(e, t, i) {
            if ($.isFunction(e)) return e.apply(t, i);
        },
        camelize: function(e) {
            var t = this;
            return String(e || "").split("-").map(function(e, i) {
                return i ? t.capitalize(e) : e;
            }).join("");
        },
        capitalize: function(e) {
            return e.charAt(0).toUpperCase() + e.substr(1);
        },
        ceil: Math.ceil,
        classify: function(e) {
            return this.capitalize(this.camelize(e));
        },
        debounce: function(e, t, i) {
            var n, s, a, o, r, l = this, c = function() {
                var h = l.now() - o;
                h < t && h >= 0 ? n = setTimeout(c, t - h) : (n = null, i || (r = e.apply(a, s), 
                n || (a = s = null)));
            };
            return function() {
                a = this, s = arguments, o = l.now();
                var h = i && !n;
                return n || (n = setTimeout(c, t)), h && (r = e.apply(a, s), a = s = null), r;
            };
        },
        floor: Math.floor,
        isPresent: function(e) {
            return null !== e && void 0 !== e;
        },
        lastChar: function(e) {
            return e.substr(e.length - 1);
        },
        now: Date.now || function() {
            return new Date().getTime();
        },
        parse: function(e, t) {
            return t && $.each(t, function(t, i) {
                e = e.replace(new RegExp("{{" + t + "}}", "g"), i);
            }), e;
        },
        randomInt: function(e, t) {
            return Math.floor(Math.random() * (t - e + 1)) + e;
        },
        round: function(e, t) {
            var i = Math.pow(10, t || 0);
            return Math.round((e || 0) * i) / i;
        },
        setInterval: function(e, t, i) {
            return setInterval(function() {
                i.call(e);
            }, t);
        },
        setTimeout: function(e, t, i) {
            return setTimeout(function() {
                i.call(e);
            }, t);
        }
    };
}(window), function(e) {
    "use strict";
    e.Cookies = Class.extend(Component, {
        initialize: function(e) {
            this.parent(e);
            var t = this;
            this.cookie = "acceptedCookies=true", document.cookie && document.cookie.indexOf(this.cookie) >= 0 ? this.$elem.hide() : this.$elem.show(), 
            $("button", e).click(function() {
                t.close();
            });
        },
        close: function() {
            this.$elem.hide();
            var e = new Date();
            e.setTime(e.getTime() + 31536e6);
            var t = "expires=" + e.toUTCString();
            document.cookie = this.cookie + "; " + t + "; path=/";
        }
    });
}(components), function(e) {
    "use strict";
    e.DayNight = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            this.$btnMode = $(".day-night-btn-mode", e), this.$images = $(".day-night-images", e), 
            this.$image = this.$images.children(), this._setModeIsAllowed = !0, this.mode = null, 
            this.$btnMode.bind("click", function() {
                i.setMode($(this).data("mode"));
            }), this.setMode(this.options.mode);
        },
        setMode: function(e) {
            if (this._setModeIsAllowed && e !== this.mode) {
                var t = this.$image.filter('[data-mode="' + e + '"]');
                t.appendTo(this.$images), utils.setTimeout(this, 20, function() {
                    t.addClass("is-active"), utils.setTimeout(this, 800, function() {
                        this.$image.not(t).removeClass("is-active"), this._setModeIsAllowed = !0;
                    });
                }), this.$elem.removeClass("is-" + this.mode).addClass("is-" + e), this.$btnMode.removeClass("is-active").filter('[data-mode="' + e + '"]').addClass("is-active"), 
                this.mode = e, this._setModeIsAllowed = !1;
            }
        }
    });
}(components), function(e) {
    "use strict";
    e.Fullscreen = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t), this.$content = $(".fullscreen-content", e), this._threshold = MQ.phablet, 
            wdw.on("resize.FullScreen", this._onResize, this);
        },
        _onResize: function(e, t) {
            if (this._setHeight("auto"), e > this._threshold) {
                var i = this.$content.height(), n = t - app.$nav.height() - app.$footer.height();
                this._setHeight(n > i ? n : i);
            }
        },
        _setHeight: function(e) {
            TL.set(this.$elem, {
                height: e
            });
        }
    });
}(components), function(e) {
    "use strict";
    e.HeaderSlideshow = Class.extend(Component, {
        initialize: function(e) {
            this.parent(e);
            var t = this;
            t.$elem = e, t.$slides = $(".header-slideshow-entries li", t.$elem), t.$slideslist = $(".header-slideshow-entries", t.$elem), 
            t.$slidesimgcontainer = $(".header-slideshow-entries li .image", t.$elem), t.$slidesimg = $(".header-slideshow-entries li .image img", t.$elem), 
            t.$slidesvidcontainer = $(".header-slideshow-entries li .video", t.$elem), t.$slidesvid = $(".header-slideshow-entries li .video video", t.$elem), 
            t.$slidesnav = $(".header-slideshow-nav li, .header-slideshow-nav-home li", t.$elem), 
            t.$btnPlay = $(".btn-play", t.$elem), t.slideshowInterval = 6, t.autoplay = !0, 
            t.screenSize = "desktop", t.type = $(".header-slideshow").data("type"), t.isPhoneUser = window.screen.width <= 740, 
            t.$btnPlay.on("click", function() {
                var e, i = $(this).data("youtube-url");
                $.each(i.split("?")[1].split("&"), function(t, i) {
                    var n = i.split("="), s = n[0], a = n[1];
                    "v" === s && (e = a);
                });
                var n = t.getActiveVideo(), s = new components.Modal({
                    classes: "modal-youtube"
                }), a = utils.parse(templates.youtube, {
                    id: e
                });
                s.on("hide", function() {
                    n.play();
                }), n.pause(), s.content(a).show();
            }), t.$slides.length && (t.$slidesnav.click(function(e) {
                e.preventDefault(), t.autoplay = !1, t.slideTo($(this).index());
            }), t.$slides.length <= 1 && t.$slidesnav.hide(), t.$slidesimg.length && t.loadImage(0), 
            t.slideTo(0)), wdw.on("resize.HeaderSlideshow", function(e, i) {
                "home" !== t.type && (i -= 100), t.resize(e, i);
            }).trigger("resize");
        },
        loadImage: function(e) {
            var t = this;
            preloadImage(t.$slidesimg.eq(e), function() {
                t.resize();
                var i = e + 1;
                i < t.$slidesimg.length && t.loadImage(i);
            });
        },
        slideTo: function(e) {
            var t = this;
            clearTimeout(t.slideshowTimeout), t.$slidesnav.removeClass("active"), t.$slidesnav.eq(e).addClass("active"), 
            t.$slides.removeClass("active"), t.activeSlide = t.$slides.eq(e), t.activeSlide.addClass("active"), 
            t.isVideoSlideActive = 1 === t.activeSlide.has(".video").length, t.autoplay ? (t.interval = t.slideshowInterval, 
            t.isVideoSlideActive && !t.isPhoneUser && (t.interval = t.getActiveVideo().duration, 
            t.playVideo()), t.slideshowTimeout = setTimeout(function() {
                if (t.autoplay && t.$slides.length > 1) {
                    var i = e + 1;
                    i >= t.$slides.length && (i = 0), t.slideTo(i);
                }
            }, 1e3 * t.interval)) : t.isVideoSlideActive && !t.isPhoneUser && t.playVideo();
        },
        getActiveVideo: function() {
            return $(".header-slideshow-entries .active").find("video").get(0);
        },
        playVideo: function() {
            var e = this.getActiveVideo();
            e.currentTime && (e.currentTime = 0), e.play();
        },
        scrollTo: function(e) {
            $("html, body").animate({
                scrollTop: e.offset().top
            }, 500);
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.screenSize = "desktop", i.w <= 1020 && (i.screenSize = "phablet"), 
            i.w <= 740 && (i.screenSize = "phone");
            var n = i.$elem.width() / 1440 * 900;
            n > i.h && (n = i.h), "phone" === i.screenSize && (n = i.w), i.$slideslist.height(n);
            for (var s = 0; s < i.$slidesimgcontainer.length; s++) resizeToFit({
                container: i.$slidesimgcontainer.eq(s),
                image: i.$slidesimg.eq(s)
            });
            for (s = 0; s < i.$slidesvidcontainer.length; s++) resizeToFit({
                container: i.$slidesvidcontainer.eq(s),
                image: i.$slidesvid.eq(s)
            });
        }
    });
}(components), function(e) {
    "use strict";
    e.ImageGallery = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            if (this.$elem = e, this.$pane = $(".image-gallery-pane", e), this.$block = $(".image-gallery-block", e), 
            this.$image = $(".image-gallery-image", e), this.$imageSmall = this.$image.filter(".is-small"), 
            this.$imageLarge = this.$image.filter(".is-large"), this.$btnNext = $(".image-gallery-btn-next", e), 
            this.$btnPrev = $(".image-gallery-btn-prev", e), this.$imagePortrait = this.$image.filter(".is-portrait"), 
            this.$imageLandscape = this.$image.filter(".is-landscape"), this._type = e.data("type"), 
            this._index = 0, this._gutter = 10, this._limit = null, this._length = this.$block.length, 
            this._lengthIndexBased = this._length - 1, this._lengthLargeImages = this.$imageLarge.length, 
            this._breakpoints = {
                smallPhone: {
                    amount: 1
                },
                phone: {
                    amount: 2
                },
                phablet: {
                    amount: 2
                },
                phabletBig: {
                    amount: 3
                },
                tablet: {
                    amount: 3
                },
                netbook: {
                    amount: 3
                },
                laptop: {
                    amount: 3
                },
                desktop: {
                    amount: 4
                }
            }, this.$image.length) {
                this.modal = new components.Modal({
                    classes: "modal-image-gallery"
                }), this.loader = new components.Loader({
                    classes: "is-centered",
                    spinner: {
                        color: COLORS[this._type]
                    }
                }), wdw.on("resize.ImageGallery", function() {
                    i.resize(), i.to(Math.min(i._index, i._limit), !0);
                }), this.$btnNext.bind("click", function() {
                    i.next();
                }), this.$btnPrev.bind("click", function() {
                    i.prev();
                }), this.$image.bind("click", function() {
                    i.showImage($(this));
                });
                var n = new Hammer(e.get(0));
                n.get("swipe").set({
                    direction: Hammer.DIRECTION_HORIZONTAL
                }), n.on("swipeleft", function() {
                    i.next();
                }), n.on("swiperight", function() {
                    i.prev();
                });
            }
        },
        next: function() {
            this._index < this._limit && this.to(this._index + 1);
        },
        prev: function() {
            this._index > 0 && this.to(this._index - 1);
        },
        resize: function() {
            var e, t, i, n, s, a = app.$elem.width(), o = this._breakpoints[utils.breakpoint(a)];
            o.amount > 1 ? (s = a - this._gutter * (o.amount - 1), t = utils.floor(s / o.amount), 
            t -= t % 2, n = t + s % t, i = t * (this._length - this._lengthLargeImages) + this._gutter * this._lengthIndexBased + n * this._lengthLargeImages) : (t = n = a - a % 2, 
            i = t * this._length), e = (t - this._gutter) / 2, TL.set(this.$pane, {
                width: i
            }), TL.set(this.$imageSmall, {
                height: e,
                width: e
            }), TL.set(this.$imageLarge, {
                height: t,
                width: n
            }), TL.set(this.$imagePortrait, {
                height: t,
                width: e
            }), TL.set(this.$imageLandscape, {
                height: e,
                width: t
            }), this._limit = Math.max(this._length - o.amount, 0);
        },
        showImage: function(e) {
            var t = this, i = e.data("index"), n = e.data();
            n.style = "height:" + ($window.height() - 96) + "px;width:" + ($window.width() - 96) + "px;", 
            n.type = t._type;
            var s = utils.parse(templates.image.join(""), n);
            this.loader.setParent(e).loadImages(n.src, function() {
                t.modal.content(s).show();
                var e = $(".modal-image-gallery-container"), n = $("img", e);
                n.attr("data-width", n.width()), n.attr("data-height", n.height()), resizeToFit({
                    container: e,
                    image: n,
                    fit: !0
                });
                var a = $(".image-gallery-modal-btn-prev"), o = $(".image-gallery-modal-btn-next");
                a.click(function(e) {
                    e.preventDefault();
                    var n = $(".image-gallery-image[data-index=" + (i - 1) + "]", t.$elem);
                    n.length || (n = $(".image-gallery-image[data-index=" + ($(".image-gallery-image", t.$elem).length - 1) + "]", t.$elem)), 
                    t.showImage(n);
                }), o.click(function(e) {
                    e.preventDefault();
                    var n = $(".image-gallery-image[data-index=" + (i + 1) + "]", t.$elem);
                    n.length || (n = $(".image-gallery-image[data-index=0]", t.$elem)), t.showImage(n);
                });
            });
        },
        to: function(e, t) {
            var i = -this.$block.eq(e).position().left;
            t ? TL.set(this.$pane, {
                x: i
            }) : TL.to(this.$pane, 4 * SPEED, {
                ease: Power4.easeInOut,
                x: i
            }), this._index = e, this.$btnPrev.toggleClass("is-disabled", 0 === e), this.$btnNext.toggleClass("is-disabled", e === this._limit);
        }
    });
}(components), function(e) {
    "use strict";
    e.InputNumber = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this, n = {
                38: "increment",
                40: "decrement"
            }, s = {
                13: {
                    fnc: "_blur",
                    params: [ !1 ]
                },
                27: {
                    fnc: "_blur",
                    params: [ !0 ]
                }
            };
            this._canceled = !1, this._val = e.val(), this._min = this.data.min, this._max = this.data.max, 
            this.onBlur = null, this.onFocus = null, e.on("focus", function() {
                i._onFocus();
            }), e.on("blur", function() {
                i._onBlur();
            }), e.on("keydown", function(e) {
                var t = n[e.keyCode];
                t && (e.preventDefault(), utils.call(i[t], i));
            }), e.on("keyup", function(e) {
                var t = s[e.keyCode];
                t && utils.call(i[t.fnc], i, t.params);
            }), utils.isPresent(this._val) ? this.val(this._val) : utils.isPresent(this._min) ? this.val(this._min) : this.val(0);
        },
        _blur: function(e) {
            this._canceled = e, this.$elem.blur();
        },
        _onBlur: function() {
            this.val(this._canceled ? this._val : this.$elem.val()), this._canceled = !1, utils.call(this.onBlur, this);
        },
        _onFocus: function() {
            utils.call(this.onFocus, this);
        },
        increment: function() {
            this.val(this._val + 1);
        },
        decrement: function() {
            this.val(this._val - 1);
        },
        val: function(e) {
            if (!utils.isPresent(e)) return this._val;
            var t = parseInt(e, 10), i = isNaN(t) ? this._min || this._val : t;
            utils.isPresent(this._min) && i < this._min && (i = this._min), utils.isPresent(this._max) && i > this._max && (i = this._max), 
            this._val = i, this.$elem.val(i);
        }
    });
}(components), function(e) {
    "use strict";
    e.Loader = Class.extend(Component, {
        initialize: function() {
            this._defaultOptions = {
                spinner: {
                    color: "#ffffff"
                }
            };
            var e, t = arguments[0], i = arguments[1], n = !0, s = !1, a = $.isPlainObject(t) ? t : i || {};
            t && t.jquery ? (e = t, n = !1) : (e = $(".loader--container"), n = !1, s = !0), 
            s ? this.$elem = e : this.parent(e, a), n && e.append(this._createSpinner(this.options.spinner).el), 
            this.$parent = a.$parent || e.parent(), this._timeout = null, this._isActive = !1;
        },
        _createSpinner: function(e) {
            return new Spinner({
                lines: 17,
                length: 0,
                width: 21,
                radius: 20,
                scale: .25,
                color: e.color,
                opacity: 0,
                speed: 2,
                hwaccel: !0
            }).spin();
        },
        hide: function(e) {
            this.$elem.removeClass("is-active"), utils.setTimeout(this, this._isActive ? 200 : 0, function() {
                this.$elem.remove(), utils.call(e, this);
            }), this._isActive = !1;
        },
        loadImages: function(e, t) {
            if (e && e.length) {
                var i = this, n = new PxLoader();
                e.jquery ? e.each(function() {
                    var e = $(this).data("src");
                    this.src = e, n.addImage(e);
                }) : "array" === $.type(e) ? $.each(e, function() {
                    n.addImage(this);
                }) : "string" === $.type(e) && n.addImage(e), n.addCompletionListener(function() {
                    clearTimeout(i._timeout), i.hide(t);
                }), n.start(), this._timeout = utils.setTimeout(this, 200, function() {
                    this.show();
                });
            } else utils.call(t, this);
        },
        setParent: function(e) {
            return this.$parent = e, this;
        },
        show: function(e) {
            this.$elem.appendTo(this.$parent), utils.setTimeout(this, 20, function() {
                this.$elem.addClass("is-active"), utils.setTimeout(this, 200, function() {
                    utils.call(e, this);
                });
            }), this._isActive = !0;
        }
    });
}(components), function(e) {
    "use strict";
    e.Maps = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            i.elem = e, i.initialData = t.data, i.markerFunction = t.markerFunction, i.mapsContainer = $(".google-maps-container", i.elem), 
            i.initializeMaps();
        },
        initializeMaps: function() {
            var e = this, t = {
                center: {
                    lat: 20,
                    lng: 0
                },
                zoom: 3,
                scrollwheel: !1,
                disableDefaultUI: !0,
                zoomControl: !0,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL
                },
                styles: [ {
                    stylers: [ {
                        saturation: -85
                    }, {
                        lightness: -70
                    }, {
                        gamma: .9
                    }, {
                        hue: "#00b2ff"
                    } ]
                }, {
                    featureType: "water",
                    stylers: [ {
                        lightness: 5
                    }, {
                        saturation: -53
                    } ]
                } ]
            };
            e.map = new google.maps.Map(e.mapsContainer.get(0), t), e.icon = {
                url: e.elem.data("icon"),
                scaledSize: new google.maps.Size(33, 19.5),
                size: new google.maps.Size(33, 19),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(22, 13)
            }, e.setData(e.initialData);
        },
        setData: function(e) {
            var t = this;
            if (t.data && t.data.length) for (var i = 0; i < t.data.length; i++) t.markers[i].setMap(null);
            for (var n = [], s = 0; s < e.length; s++) {
                var a = e[s];
                isNaN(a.lat) || isNaN(a.lng) || n.push(a);
            }
            t.data = n, t.infoWindows = [], t.markers = [];
            for (var o = 0; o < t.data.length; o++) t.generateContent(o), t.setMarker(o);
            t.data.length && t.centerMap(t.data[0].country);
        },
        centerMap: function(e) {
            for (var t = this, i = [], n = 0; n < t.data.length; n++) i.push(new google.maps.LatLng(t.data[n].lat, t.data[n].lng));
            for (var s = new google.maps.LatLngBounds(), a = 0; a < i.length; a++) s.extend(i[a]);
            t.map.fitBounds(s);
            var o = google.maps.event.addListener(t.map, "idle", function() {
                106 === e && t.map.setZoom(6), t.map.getZoom() > 15 && t.map.setZoom(14), google.maps.event.removeListener(o);
            });
        },
        generateContent: function(e) {
            var t = this, i = "";
            i += '<div class="info-window">', i += t.data[e].website ? '<h3><a target="_blank" href="' + t.data[e].website + '">' + t.data[e].name + "</a></h3>" : "<h3>" + t.data[e].name + "</h3>", 
            i += "</div>", t.data[e].html = i;
        },
        setMarker: function(e) {
            var t = this, i = t.data[e];
            t.infoWindows[e] = new google.maps.InfoWindow({
                content: i.html
            }), t.markers[e] = new google.maps.Marker({
                position: {
                    lat: i.lat,
                    lng: i.lng
                },
                map: t.map,
                title: i.name,
                icon: t.icon
            }), google.maps.event.addListener(t.markers[e], "click", function() {
                t.markerFunction && t.markerFunction(i.id);
            }), google.maps.event.addListener(t.infoWindows[e], "closeclick", function() {});
        },
        openInfoWindow: function(e) {
            var t = this;
            t.infoWindows[e].open(t.map, t.markers[e]), google.maps.event.addListener(t.markers[e], "click", function() {
                t.closeInfoWindow(e);
            });
        },
        closeInfoWindow: function(e) {
            var t = this;
            google.maps.event.addListener(t.markers[e], "click", function() {
                t.openInfoWindow(e);
            });
        }
    });
}(components), function(e) {
    "use strict";
    e.Modal = Class.extend(Component, {
        initialize: function() {
            var e = arguments[0], t = arguments[1], i = e && e.jquery ? e : $(templates.modal.main.join("")), n = $.isPlainObject(e) ? e : t;
            this._defaultOptions = {
                hasBox: !1
            }, this.parent(i, n), this._eventListeners = {
                hide: []
            }, this.$content = $(".modal-content", i);
        },
        _addEventListeners: function() {
            var e = this, t = doc.addToQueue("escape", function() {
                this.hide();
            }, this);
            this.$elem.bind("click", function() {
                e.hide(), doc.removeFromQueue("escape", t);
            }), this.$content.children().bind("click", function(e) {
                e.stopPropagation();
            });
        },
        _removeEventListeners: function() {
            this.$elem.unbind(), this.$content.children().unbind();
        },
        content: function(e) {
            return this.options.hasBox && (e = utils.parse(templates.modal.box.join(""), {
                content: e
            })), this.$content.html(e), this;
        },
        hide: function(e) {
            var t = this;
            return this._removeEventListeners(), TL.to(this.$elem, SPEED, {
                opacity: 0
            }), TL.to(this.$content, SPEED, {
                scale: .9,
                onComplete: function() {
                    t.$elem.detach(), $body.removeClass("u-hide-overflow"), utils.call(e, t), t._callEventListeners("hide");
                }
            }), this;
        },
        show: function(e) {
            var t = this;
            return $body.addClass("u-hide-overflow"), this.$elem.appendTo($body), TL.to(this.$elem, SPEED, {
                opacity: 1
            }), TL.to(this.$content, SPEED, {
                scale: 1,
                onComplete: function() {
                    t._addEventListeners(), utils.call(e, t);
                }
            }), this;
        }
    });
}(components), function(e) {
    "use strict";
    e.PopupOrderAccessory = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            i.$elem = e, i.$close = $(".close", i.$elem), i.$bg = $(">.bg", i.$elem), i.$table = $(">.table", i.$elem), 
            i.$title = $(".content >.left >h3", i.$elem), i.$text = $(".content >.left >p", i.$elem), 
            i.$price = $(".content >.left >.price-tag >.price", i.$elem), i.$images = $(".content >.left >.images", i.$elem), 
            i.$buckles = $(".content >.right form .buckles", i.$elem), i.$bucklesLabel = $(".content >.right form .buckles-label", i.$elem), 
            i.$sizes = $(".content >.right form .sizes", i.$elem), i.$sizesLabel = $(".content >.right form .sizes-label", i.$elem), 
            i.$submit = $(".content >.right form .btn-submit", i.$elem), i.$error = $(".content >.right form .error", i.$elem), 
            i.$formcontainer = $(".form-container", i.$elem), i.$thanksontainer = $(".thanks-container", i.$elem), 
            i.amount = new components.Select($(".select-amount", i.$elem)), i.country = new components.Select($(".select-country", i.$elem)), 
            i.$name = $("#accessory_name", i.$elem), i.$email = $("#accessory_email", i.$elem), 
            i.$city = $("#accessory_city", i.$elem), i.$zip = $("#accessory_zipcode", i.$elem), 
            i.$state = $("#accessory_state", i.$elem), i.$street = $("#accessory_street", i.$elem), 
            i.$number = $("#accessory_number", i.$elem), i.id = null, i.url = i.$elem.data("url"), 
            i.$close.click(function(e) {
                e.preventDefault(), i.close();
            }), i.$bg.click(function(e) {
                e.preventDefault(), i.close();
            }), i.$submit.click(function(e) {
                e.preventDefault(), i.submit();
            });
        },
        validateField: function(e) {
            var t = !0;
            return e.val() || (e.addClass("has-error"), t = !1), t;
        },
        validate: function() {
            var e = this;
            $("form .has-error", e.$elem).removeClass("has-error");
            var t = !0;
            return e.validateField(e.$name) || (t = !1), e.validateField(e.$email) || (t = !1), 
            e.validateField(e.$city) || (t = !1), e.validateField(e.$zip) || (t = !1), e.validateField(e.$street) || (t = !1), 
            e.validateField(e.$number) || (t = !1), e.country.val() && "0" !== e.country.val() || (t = !1, 
            $(".select-country", e.$elem).addClass("has-error")), 0 !== e.data.buckles.length && ($(".buckles input[name=buckles]:checked", e.$elem).val() || (t = !1, 
            e.$buckles.addClass("has-error"))), 0 !== e.data.sizes.length && ($(".sizes input[name=sizes]:checked", e.$elem).val() || (t = !1, 
            e.$sizes.addClass("has-error"))), t || e.error(), t;
        },
        submit: function() {
            var e = this;
            if (null !== e.id && e.validate()) {
                var t = {
                    country_id: e.country.val(),
                    amount: e.amount.val(),
                    name: e.$name.val(),
                    state: e.$state.val(),
                    email: e.$email.val(),
                    city: e.$city.val(),
                    zipcode: e.$zip.val(),
                    street: e.$street.val(),
                    number: e.$number.val()
                };
                if (0 !== e.data.buckles.length) {
                    var i = $(".buckles input[name=buckles]:checked", e.$elem).val();
                    i && (t["buckle!" + i] = !0);
                }
                if (0 !== e.data.sizes.length) {
                    var n = $(".sizes input[name=sizes]:checked", e.$elem).val();
                    n && (t["size!" + n] = !0);
                }
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-Token": $('meta[name="_token"]').attr("content")
                    }
                }), $.ajax({
                    url: e.url + "service/accessories/" + e.id + "/order",
                    method: "POST",
                    data: t,
                    success: function() {
                        e.$formcontainer.hide(), e.$thanksontainer.show();
                    },
                    error: function(t) {
                        422 === t.status && e.error(t.responseJSON);
                    }
                });
            }
        },
        error: function(e) {
            var t = this, i = "";
            e ? $.each(e, function(e, n) {
                $("form #accessory_" + e, t.$elem).addClass("has-error"), i = n[0];
            }) : i = t.$elem.data("error"), t.$error.text(i);
        },
        open: function(e) {
            var t = this;
            t.id = e, t.$elem.show(), setTimeout(function() {
                t.$elem.removeClass("hide-bg");
            }, 10), t.ajaxGetInfo = $.ajax({
                url: t.url + "service/accessories/" + e,
                method: "GET",
                success: function(e) {
                    t.fillHtml(e);
                },
                error: function() {}
            });
        },
        fillHtml: function(e) {
            var t = this;
            t.data = e, t.$title.text(e.details.title), t.$text.text(e.details.text), t.$price.text("€" + e.details.price);
            for (var i = "", n = 0; n < e.images.length; n++) i += '<li class="image"><img src="' + e.images[n].image + '" alt="' + e.details.title + '"/></li>';
            t.$images.html(i);
            var s = "";
            0 !== e.buckles.length ? ($.each(e.buckles, function(e, t) {
                s += '<label class="has-input"><input name="buckles" value="' + e + '" type="radio"/>' + t + "</label>";
            }), t.$bucklesLabel.show()) : t.$bucklesLabel.hide(), t.$buckles.html(s);
            var a = "";
            0 !== e.sizes.length ? ($.each(e.sizes, function(e, t) {
                a += '<label class="has-input"><input name="sizes" value="' + e + '" type="radio"/>' + t + "</label>";
            }), t.$sizesLabel.show()) : t.$sizesLabel.hide(), t.$sizes.html(a), t.$elem.removeClass("hide-content");
        },
        close: function() {
            var e = this;
            e.ajaxGetInfo.abort(), e.id = null, e.data = null, e.$title.text(""), e.$text.text(""), 
            e.$price.text(""), e.$images.html(""), e.$buckles.html(""), e.$elem.addClass("hide-bg"), 
            e.$elem.addClass("hide-content"), setTimeout(function() {
                e.$elem.hide(), e.$formcontainer.show(), e.$thanksontainer.hide();
            }, 350);
        },
        resize: function() {
            var e = this;
            e.$bg.height(e.$table.height() + parseInt(e.$table.css("paddingTop")) + parseInt(e.$table.css("paddingBottom")));
        }
    });
}(components), function(e) {
    "use strict";
    e.PopupSubscribe = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            i.$elem = e, i.$close = $(".close", i.$elem), i.$bg = $(">.bg", i.$elem), i.$table = $(">.table", i.$elem), 
            i.$submit = $(".content form .btn-submit", i.$elem), i.$error = $(".content form .error", i.$elem), 
            i.$formcontainer = $(".form-container", i.$elem), i.$thanksontainer = $(".thanks-container", i.$elem), 
            i.sector = new components.Select($(".select-sector", i.$elem)), i.country = new components.Select($(".select-country", i.$elem)), 
            i.$fname = $("#subscribe_fname", i.$elem), i.$lname = $("#subscribe_lname", i.$elem), 
            i.$email = $("#subscribe_email", i.$elem), i.$city = $("#subscribe_city", i.$elem), 
            i.$zip = $("#subscribe_zipcode", i.$elem), i.$state = $("#subscribe_state", i.$elem), 
            i.$address = $("#subscribe_address", i.$elem), i.$company = $("#subscribe_company", i.$elem), 
            i.$jobfunction = $("#subscribe_function", i.$elem), i.url = i.$elem.data("url"), 
            i.$close.click(function(e) {
                e.preventDefault(), i.close();
            }), i.$bg.click(function(e) {
                e.preventDefault(), i.close();
            }), i.$submit.click(function(e) {
                e.preventDefault(), i.submit();
            });
        },
        validateField: function(e) {
            var t = !0;
            return e.val() || (e.addClass("has-error"), t = !1), t;
        },
        validate: function() {
            var e = this;
            $("form .has-error", e.$elem).removeClass("has-error");
            var t = !0;
            return e.validateField(e.$fname) || (t = !1), e.validateField(e.$lname) || (t = !1), 
            e.validateField(e.$email) || (t = !1), e.validateField(e.$city) || (t = !1), e.validateField(e.$zip) || (t = !1), 
            e.validateField(e.$address) || (t = !1), e.validateField(e.$company) || (t = !1), 
            e.validateField(e.$jobfunction) || (t = !1), e.country.val() && "null" !== e.country.val() || (t = !1, 
            $(".select-country", e.$elem).addClass("has-error")), t || e.error(), t;
        },
        submit: function() {
            var e = this;
            if (null !== e.id && e.validate()) {
                var t = {
                    country_id: e.country.val(),
                    "function": e.$jobfunction.val(),
                    fname: e.$fname.val(),
                    lname: e.$lname.val(),
                    state: e.$state.val(),
                    email: e.$email.val(),
                    city: e.$city.val(),
                    zipcode: e.$zip.val(),
                    address: e.$address.val(),
                    company: e.$company.val()
                };
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-Token": $('meta[name="_token"]').attr("content")
                    }
                }), $.ajax({
                    url: e.url + "press/subscribe",
                    method: "POST",
                    data: t,
                    success: function() {
                        e.$formcontainer.hide(), e.$thanksontainer.show();
                    },
                    error: function(t) {
                        422 === t.status && e.error(t.responseJSON);
                    }
                });
            }
        },
        error: function(e) {
            var t = this, i = "";
            e ? $.each(e, function(e, n) {
                $("form #subscribe_" + e, t.$elem).addClass("has-error"), i = n[0];
            }) : i = t.$elem.data("error"), t.$error.text(i);
        },
        open: function() {
            var e = this;
            e.$formcontainer.show(), e.$thanksontainer.hide(), e.$elem.show(), setTimeout(function() {
                e.resize(), e.$elem.removeClass("hide-bg"), e.$elem.removeClass("hide-content");
            }, 10);
        },
        close: function() {
            var e = this;
            e.$elem.addClass("hide-bg"), e.$elem.addClass("hide-content"), setTimeout(function() {
                e.$elem.hide(), e.$formcontainer.show(), e.$thanksontainer.hide();
            }, 350);
        },
        resize: function() {
            var e = this;
            e.$bg.height(e.$table.height() + parseInt(e.$table.css("paddingTop")) + parseInt(e.$table.css("paddingBottom")));
        }
    });
}(components), function(e) {
    "use strict";
    e.Select = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            this.$label = $(".select-label", e), this.$native = $(".select-native", e), this.$option = this.$native.children(), 
            this.onBlur = null, this.onFocus = null, this.onChange = null, this.$native.on("blur", function() {
                i._blur();
            }), this.$native.on("focus", function() {
                i._focus();
            }), this.$native.on("change", function() {
                i._change();
            }), this._updateLabel();
        },
        _blur: function() {
            utils.call(this.onBlur, this);
        },
        _change: function() {
            utils.call(this.onChange, this, [ this.val() ]), this._updateLabel();
        },
        _focus: function() {
            utils.call(this.onFocus, this);
        },
        _updateLabel: function() {
            this.$label.text(this.$option.filter(":selected").text());
        },
        setOptions: function(e) {
            var t = "";
            $.each(e, function(e, i) {
                t += '<option value="' + i.value + '">' + i.label + "</option>";
            }), this.$option = $(t), this.$native.html(this.$option);
        },
        trigger: function(e) {
            this.$native.trigger(e);
        },
        val: function(e) {
            return utils.isPresent(e) ? (this.$native.val(e), void this._updateLabel()) : this.$native.val();
        }
    });
}(components), function(e) {
    "use strict";
    e.Slider = Class.extend(Component, {
        initialize: function(e, t) {
            this._defaultOptions = {
                min: 0,
                max: 100,
                scaleStep: 10,
                scaleOffset: 0
            }, this.parent(e, t);
            var i = this;
            if (this.$elem = e, this.$scale = $(".slider-scale", e), this.$range = $(".slider-range", e), 
            this.$active = $(".slider-active", e), this._percentage = null, this._min = this.options.min, 
            this._max = this.options.max, this._minAbs = Math.abs(this._min), this._range = this._max + this._minAbs, 
            this._eventListeners = {
                panend: [],
                panmove: [],
                panstart: [],
                tap: []
            }, this.onPanEnd = null, this.onPanStart = null, e.length) {
                var n = new Hammer(this.$range.get(0));
                n.get("pan").set({
                    direction: Hammer.DIRECTION_VERTICAL,
                    threshold: 0
                }), n.on("panstart", function() {
                    app.onPanStart(i.$range), utils.call(i.onPanStart, i, [ i ]);
                }), n.on("panmove", function(e) {
                    i._onPanMove(e.srcEvent);
                }), n.on("panend", function() {
                    app.onPanEnd(i.$range), utils.call(i.onPanEnd, i, [ i.val() ]);
                }), n.on("tap", function(e) {
                    i._onTap(e.srcEvent), i._callEventListeners("tap", [ i.val() ]);
                }), this.$range.addClass("u-is-pannable"), this._createScale();
            }
        },
        _createScale: function() {
            for (var e = this.options.scaleOffset, t = this.options.scaleStep, i = this._max - e, n = this._min + e; i >= n; ) this.$scale.append('<div class="slider-scale-value" style="bottom:' + this._percentageForVal(i) + '%">' + i + "</div>"), 
            i -= t;
        },
        _onPanMove: function(e) {
            this._setPercentage(this._percentageForPosition(e.pageY));
        },
        _onTap: function(e) {
            this._setPercentage(this._percentageForPosition(e.pageY), !0);
        },
        _percentageForPosition: function(e) {
            return 100 - (e - this.$range.offset().top) / this.$range.height() * 100;
        },
        _percentageForVal: function(e) {
            return utils.round((e + this._minAbs) / this._range * 100);
        },
        _setPercentage: function(e, t) {
            e = utils.round(e, 2), e < 0 ? e = 0 : e > 100 && (e = 100), this._percentage = e, 
            t ? TL.to(this.$active, 1, {
                ease: Power4.easeInOut,
                height: e + "%"
            }) : TL.set(this.$active, {
                height: e + "%"
            });
        },
        val: function(e) {
            return utils.isPresent(e) ? void this._setPercentage(this._percentageForVal(e), !0) : utils.round(this._range / 100 * this._percentage) - this._minAbs;
        }
    });
}(components), function(e) {
    "use strict";
    e.ThreeSixty = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this, n = $("canvas", e), s = n.get(0);
            this.$canvas = n, this.$modelHeader = $(".modelheader", e), this.$modelLinks = $(".model-links", e), 
            this.$modelSpecification = $(".model-specifications", e), this.$watchModels = $(".watch-models", e), 
            this.$btnModel = $(".btn-model", this.$watchModels), this.$watchContainer = $(".three-sixty-watch-container", e), 
            this.spinnerTarget = document.getElementById("spinner"), this._images = [], this._index = null, 
            this._pageX = null, this._length = null, this._hammer = new Hammer(s), this._ctx = s.getContext("2d"), 
            this._prevModelIndex = null, this._spinner = null, this._initSpinner(), this.loader = new components.Loader($(this._spinner.el), {
                $parent: this.$watchContainer,
                classes: "is-centered"
            }), wdw.on("resize.ThreeSixty", this._onResize, this), this.$btnModel.bind("click", function() {
                var e = i.$btnModel.index(this);
                i._prevModelIndex !== e && i.setModel(e);
            }), this._hammer.get("pan").set({
                direction: Hammer.DIRECTION_HORIZONTAL,
                threshold: 0
            }), this.setModel(0);
        },
        _onPanMove: function(e) {
            var t = e - this._pageX, i = 8;
            t > i ? (this.prevImage(), this._pageX = e) : t < -i && (this.nextImage(), this._pageX = e);
        },
        _onResize: function() {
            var e = $(window).width();
            e <= 355 ? this._setCanvasSize(275) : e <= 460 ? this._setCanvasSize(300) : e <= 740 ? this._setCanvasSize(350) : e <= 1300 ? this._setCanvasSize(400) : this._setCanvasSize(500), 
            this.drawImage(this._index), this._width = this.$canvas.width(), this._height = this.$canvas.height();
        },
        _setCanvasSize: function(e) {
            this.$canvas.attr("width", e), this.$canvas.attr("height", e);
        },
        _initSpinner: function() {
            this._spinner = new Spinner({
                lines: 17,
                length: 1,
                width: 21,
                radius: 17,
                scale: .25,
                corners: 1,
                color: COLORS[this.options.type],
                opacity: 0,
                rotate: 5,
                direction: 1,
                speed: 2.2,
                trail: 60,
                fps: 20,
                zIndex: 2e9,
                className: "spinner",
                top: "75%",
                left: "50%",
                shadow: !1,
                hwaccel: !1,
                position: "absolute"
            }).spin();
        },
        setModel: function(e) {
            var t = this, i = e, n = null;
            this._spinner.spin(this.spinnerTarget), this.$modelHeader.hide().eq(e).show(), this.$modelLinks.hide().eq(e).show(), 
            this.$modelSpecification.hide().eq(e).show(), this.$btnModel.removeClass("is-active").eq(e).addClass("is-active"), 
            this.$modelSpecification.removeClass("is-active").eq(e).addClass("is-active"), $.each(this.$btnModel, function(e, t) {
                e === i && (n = $(t).data("model-id"));
            }), n && this.getThreeSixtyModel(n, function(i) {
                t.loadImages(i), t._prevModelIndex = e, i && i.length <= 1 ? t.$watchContainer.addClass("three-sixty-watch-container--static") : t.$watchContainer.hasClass("three-sixty-watch-container--static") && t.$watchContainer.removeClass("three-sixty-watch-container--static");
            });
        },
        getThreeSixtyModel: function(e, t) {
            $.ajax({
                url: BASEURL + "watches/0/model/" + e + "/threesixty",
                method: "GET",
                success: t,
                error: function(e) {
                    console.log(e);
                }
            });
        },
        disable: function() {
            this._hammer.off("panstart panmove");
        },
        drawImage: function(e) {
            var t = this, i = .5, n = .5, s = this._images[e], a = new Image();
            this._index = e, a.onload = function() {
                var e = a.width, s = a.height, o = t._width / e, r = t._height / s, l = o < r ? o : r;
                l > 1 && (l = 1);
                var c = e * l || 0, h = s * l || 0, d = t._width * i - c * i || 0, m = t._height * n - h * n || 0;
                t._ctx.clearRect(0, 0, t._width, t._height), t._ctx.drawImage(a, 0, 0, e, s, d, m, c, h), 
                t._spinner.stop();
            }, s && (a.src = s);
        },
        enable: function() {
            var e = this;
            this._hammer.on("panstart", function(t) {
                e._pageX = t.srcEvent.pageX;
            }), this._hammer.on("panmove", function(t) {
                e._onPanMove(t.srcEvent.pageX);
            });
        },
        loadImages: function(e, t) {
            var i = this;
            this.disable(), this.loader.loadImages(e, function() {
                var n = [];
                $.each(e, function() {
                    n.push(this);
                }), i._images = n, i._length = n.length, i.drawImage(0), i.enable(), utils.call(t, i);
            });
        },
        nextImage: function() {
            this.drawImage(this._index < this._length - 1 ? this._index + 1 : 0);
        },
        prevImage: function() {
            this.drawImage(this._index > 0 ? this._index - 1 : this._length - 1);
        }
    });
}(components), function(e) {
    "use strict";
    e.VideoGallery = Class.extend(Component, {
        initialize: function(e, t) {
            this._defaultOptions = {
                color: "ffffff"
            }, this.parent(e, t);
            var i = this;
            this.$video = $(".video", e), this.$iframe = $("iframe", e), this._activeVideoId = null, 
            this._width = parseInt(this.$iframe.attr("width"), 10), this._height = parseInt(this.$iframe.attr("height"), 10), 
            this._ratio = this._height / this._width, wdw.on("resize.VideoGallery", this._onResize, this), 
            this.$video.bind("click", function() {
                i.showVideo($(this).data("id"), !0);
            });
        },
        _onResize: function() {
            var e = Math.min(this._width, this.$elem.width());
            TL.set(this.$iframe, {
                height: e * this._ratio,
                width: e
            });
        },
        showVideo: function(e, t) {
            e !== this._activeVideoId && (this._activeVideoId = e, this.$iframe.attr("src", "https://player.vimeo.com/video/" + e + "?autoplay=" + (t ? 1 : 0) + "&amp;color=" + this.options.color + "&amp;title=0&amp;byline=0&amp;portrait=0"));
        }
    });
}(components), function(e) {
    "use strict";
    e.Watch = Class.extend(Component, {
        initialize: function(e) {
            this.parent(e);
            var t = this;
            this.$version = $(".watch-version", e), this.$navVersions = $(".watch-nav-versions", e), 
            this.$btnVersion = $(".btn-version", this.$navVersions), e.bind("click", function(e) {
                t.open(e.metaKey);
            }), this.$navVersions.bind("click", function(e) {
                e.stopPropagation();
            }), this.$btnVersion.bind("click", function() {
                t.setVersion(t.$btnVersion.index(this));
            }), this.setVersion(0);
        },
        open: function(e) {
            e ? window.open(this.data.href) : location.href = this.data.href;
        },
        setVersion: function(e) {
            this.$version.hide().eq(e).show(), this.$btnVersion.removeClass("is-active").eq(e).addClass("is-active");
        }
    });
}(components), function(e) {
    "use strict";
    e.FindusContact = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.maps = new components.Maps($(".component-maps", t.$elem), {
                data: [ {
                    id: 0,
                    lat: 51.2185187,
                    lng: 4.4045524
                } ]
            }), wdw.on("resize.FindusContact", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.maps.centerMap();
        }
    });
}(controllers), function(e) {
    "use strict";
    e.FindusStores = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$locations = $(".locations", t.$elem), t.$locationsContent = $(".locations > .center", t.$elem), 
            t.$stores = $(".stores-item", t.$elem), t.showAll = !0, t.selectCountry = new components.Select($(".select-country", t.$elem)), 
            t.selectCountry.onChange = function(e) {
                t.changeCountry(e);
            }, t.maps = new components.Maps($(".component-maps", t.$elem), {
                data: t.gatherData(),
                markerFunction: function(e) {
                    t.showLocationById(e);
                }
            }), wdw.on("resize.FindusStores", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        changeCountry: function(e) {
            var t = this;
            if ("null" !== e) {
                t.showAll = !1, t.$stores.hide();
                for (var i = 0; i < t.$stores.length; i++) e.toString() === t.$stores.eq(i).data("country").toString() && t.$stores.eq(i).show();
            } else t.showAll = !0, t.$stores.show();
            t.updateMap(), t.setHeight();
        },
        setHeight: function() {
            var e = this;
            e.showAll ? e.$locations.height(0) : e.$locations.height(e.$locationsContent.height() + parseInt(e.$locationsContent.css("paddingTop")) + parseInt(e.$locationsContent.css("paddingBottom")));
        },
        showLocationById: function(e) {
            var t = this;
            t.showAll = !1, t.$stores.hide();
            for (var i = 0; i < t.$stores.length; i++) e.toString() === t.$stores.eq(i).data("id").toString() && t.$stores.eq(i).show();
            t.setHeight(), $("html, body").animate({
                scrollTop: t.$locations.offset().top - 132
            }, 1e3);
        },
        gatherData: function() {
            for (var e = this, t = [], i = 0; i < e.$stores.length; i++) "none" !== e.$stores.eq(i).css("display") && t.push({
                id: e.$stores.eq(i).data("id"),
                lng: parseFloat(e.$stores.eq(i).data("lng")),
                lat: parseFloat(e.$stores.eq(i).data("lat")),
                name: e.$stores.eq(i).data("name"),
                website: e.$stores.eq(i).data("website"),
                country: e.$stores.eq(i).data("country")
            });
            return t;
        },
        updateMap: function() {
            var e = this;
            e.maps.setData(e.gatherData());
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.setHeight(), i.maps.centerMap();
        }
    });
}(controllers), function(e) {
    "use strict";
    e.Header = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$centered = $(".centered", t.$elem), t.$hamburger = $(".hamburger", t.$elem), 
            t.$navigationContainer = $(".navigation-container", t.$elem), t.$navigationSecondary = $(".navigation-secondary", t.$elem), 
            t.$navigationSecondaryList = $(".navigation-secondary-list", t.$elem), t.$navigationSecondaryListItems = $(".navigation-secondary-list > ul > li > a", t.$elem), 
            t.$navigationPrimary = $(".navigation-primary", t.$elem), t.$navigationPrimaryItems = $(".navigation-primary > ul > li > a", t.$elem), 
            t.$close = $(".icon-cross", t.$elem), t.$back = $(".icon-arrow-left", t.$elem), 
            t.$followus = $(".navigation-follow-us", t.$elem), t.view = t.$elem.data("view"), 
            t.isOpen = !1, t.activeSubNav = null, t.dontHideSubnav = !1, t.scrollBySubNav = !1, 
            t.mobile = !1, t.s = 0, $(".navigation-secondary-list.active", t.$elem).get(0) && $(".navigation-secondary-list.active", t.$elem).hasClass("use-scroll") && (t.scrollBySubNav = !0), 
            t.$hamburger.click(function(e) {
                e.preventDefault(), t.open();
            }), t.$close.click(function(e) {
                e.preventDefault(), t.close();
            }), t.$navigationPrimaryItems.click(function(e) {
                var i = $(this), n = i.data("sub");
                n && t.mobile && (e.preventDefault(), t.checkToOpenSecondaryNav(n, i, !0));
            }), t.$back.click(function(e) {
                e.preventDefault(), t.closeSecondaryNav();
            }), t.$navigationSecondaryListItems.click(function(e) {
                $(this).data("scroll-to") && (e.preventDefault(), t.scrollTo($($(this).data("scroll-to"))));
            }), wdw.on("scroll.header", function(e) {
                t.scroll(e);
            }), wdw.on("resize.header", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        checkToOpenSecondaryNav: function(e, t, i) {
            var n = this, s = $(".navigation-secondary-list." + e, n.$elem);
            s.length && (n.activeSubNav !== e ? "home" === n.view && n.s < 119 && !n.mobile && i ? $("html, body").animate({
                scrollTop: 119
            }, 300, "swing", function() {
                setTimeout(function() {
                    n.openSecondaryNav(s, t, e);
                }, 300);
            }) : "home" === n.view && n.s < 119 && !n.mobile && !i || n.openSecondaryNav(s, t, e) : i && n.closeSecondaryNav());
        },
        openSecondaryNav: function(e, t, i) {
            var n = this;
            n.activeSubNav = i, n.$navigationPrimary.addClass("inactive"), n.$followus.addClass("hide"), 
            n.$back.removeClass("hide"), n.$navigationSecondary.addClass("focus"), n.$navigationSecondaryList.removeClass("focus"), 
            e.addClass("focus"), n.$navigationPrimaryItems.removeClass("focus"), t.addClass("focus");
        },
        closeSecondaryNav: function() {
            var e = this;
            e.$navigationPrimary.removeClass("inactive"), e.$navigationSecondary.removeClass("focus"), 
            e.$navigationSecondaryList.removeClass("focus"), e.$navigationPrimaryItems.removeClass("focus"), 
            e.$followus.removeClass("hide"), e.$back.addClass("hide"), e.activeSubNav = null;
        },
        open: function() {
            var e = this;
            e.isOpen || (e.isOpen = !0, e.closeSecondaryNav(), e.$navigationContainer.show(), 
            setTimeout(function() {
                e.$elem.addClass("is-open");
            }, 10));
        },
        close: function() {
            var e = this;
            e.isOpen && (e.isOpen = !1, e.$elem.removeClass("is-open"), e.closeSecondaryNav(), 
            setTimeout(function() {
                e.mobile ? e.$navigationContainer.hide() : e.$navigationContainer.show();
            }, 300));
        },
        show: function() {
            var e = this;
            e.$centered.removeClass("hide");
        },
        hide: function() {
            var e = this;
            e.$centered.addClass("hide");
        },
        scrollTo: function(e) {
            var t = this;
            clearTimeout(t.dontHideSubnavTimeout), t.dontHideSubnav = !0, $("html, body").animate({
                scrollTop: e.offset().top - 99
            }, 500), t.dontHideSubnavTimeout = setTimeout(function() {
                t.dontHideSubnav = !1;
            }, 600);
        },
        scroll: function(e) {
            var t = this;
            t.ps = t.s, e && (t.s = e), 0 === e && (t.s = e), t.docH || (t.docH = $(document).height(), 
            t.winH = $(window).height());
            var i = 132;
            if ("home" === t.view && (i = 3 * t.winH / 4, t.mobile && (i = 58), t.s > 118 ? t.$elem.removeClass("is-big") : (t.$elem.addClass("is-big"), 
            t.mobile || t.closeSecondaryNav())), t.s > t.ps && t.hide(), t.s < t.ps && t.show(), 
            t.s < i && t.show(), t.s > t.docH - t.winH - 58 && t.show(), t.dontHideSubnav && t.show(), 
            t.scrollBySubNav) {
                var n = $(".navigation-secondary-list.active > ul > li > a", t.$elem);
                n.removeClass("active");
                for (var s = 0; s < n.length; s++) {
                    var a = $(n.eq(s).data("scroll-to"));
                    t.s > a.offset().top - 100 && (n.removeClass("active"), n.eq(s).addClass("active"));
                }
            }
        },
        resize: function(e, t) {
            var i = this;
            i.w = e, i.h = t, i.docH = $(document).height(), i.winH = $(window).height(), i.mobile = !1, 
            i.w <= 740 && (i.mobile = !0), i.mobile || i.$navigationContainer.show(), i.scroll(i.s);
        }
    });
}(controllers), function(e) {
    "use strict";
    e.Home = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            if (t.parent(e), t.$elem = e, t.$slidestrigger = $(".slideshow .slideshow-trigger > a", t.$elem), 
            t.$grid = $(".grid", t.$elem), t.$gridBigRow = $("> .custom-row", t.$grid), t.$gridItem = $(".grid-item", t.$grid), 
            t.$gridItemForceSquare = t.$gridItem.filter('[data-force-square="true"]'), t.$gridItemInstagram = $(".grid-item-instagram", t.$grid), 
            t.$gridItemInstagramImagesContainers = $(".grid-item-instagram-image", t.$grid), 
            t.$gridItemInstagramImages = $("img", t.$gridItemInstagramImagesContainers), t.$gridItemTextContent = $(".grid-item-text-content", t.$grid), 
            t.$slidestrigger.click(function(e) {
                e.preventDefault(), t.scrollTo(t.$grid);
            }), t.$grid.length) {
                t.$gridItemInstagram.length && instagram && instagram.length && (t.instagrams = instagram, 
                t.setInstagram()), this.setupFollowers();
                var i = $("p", t.$gridItemTextContent);
                // console.log(i);
                for (var n = 0; n < i.length; n++) i.html(i.text().replace("{instagramfollowers}", '<span class="followerscount">' + window.instagram_followers_count + "</span>"));
            }
            wdw.on("resize.Home", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        setInstagram: function() {
            for (var e = this, t = 0; t < e.$gridItemInstagramImagesContainers.length; t++) {
                var i = e.instagrams[t];
                e.$gridItemInstagramImagesContainers.eq(t).html('<img data-src="' + i.image_url + '" data-width="' + i.width + '" data-height="' + i.height + '" />');
            }
            e.$gridItemInstagramImages = $("img", e.$gridItemInstagramImagesContainers), e.loadInstagramImage(0), 
            e.resize();
        },
        loadInstagramImage: function(e) {
            var t = this;
            preloadImage(t.$gridItemInstagramImages.eq(e), function() {
                t.resize();
                var i = e + 1;
                i < t.$gridItemInstagramImages.length && t.loadInstagramImage(i);
            });
        },
        scrollTo: function(e) {
            $("html, body").animate({
                scrollTop: e.offset().top
            }, 500);
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.screenSize = "desktop", i.w <= 1020 && (i.screenSize = "phablet"), 
            i.w <= 740 && (i.screenSize = "phone");
            var n = i.w;
            "desktop" === i.screenSize && (n = i.w / 2), n > 900 && (n = 900), "phone" === i.screenSize && (n = "auto"), 
            i.$gridBigRow.height(n);
            var s = 0;
            "phone" === i.screenSize && (s = i.w / 3), i.$gridItem.css("minHeight", s), i.$gridItemInstagramImagesContainers.css("minHeight", 3 * s), 
            i.$gridItemTextContent.css("minHeight", s), "phone" === this.screenSize && this.$gridItemForceSquare.css("height", this.w);
            for (var a = 0; a < i.$gridItemInstagramImagesContainers.length; a++) resizeToFit({
                container: i.$gridItemInstagramImagesContainers.eq(a),
                image: i.$gridItemInstagramImages.eq(a)
            });
        },
        setupFollowers: function() {
            var e = $("#followers");
            if (e.length) {
                var t = "scroll.followers", i = new window.CountUp(e.get(0), 0, parseInt(e.data("count"), 10), 0, 4);
                wdw.on(t, function(n) {
                    n + wdw.height > e.offset().top && (wdw.off(t), i.start());
                });
            }
        }
    });
}(controllers), function(e) {
    "use strict";
    e.Innovation = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$discover = $(".image-header .btn", t.$elem), t.$content = $(">.content", t.$elem), 
            t.$discover.click(function() {
                t.scrollTo(t.$content);
            });
        },
        scrollTo: function(e) {
            $("html, body").animate({
                scrollTop: e.offset().top
            }, 500);
        }
    });
}(controllers), function(e) {
    "use strict";
    e.Press = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$tabsButtons = $(".tabs > a.btn-tab", t.$elem), t.$tabsContent = $(".tabs-content", t.$elem), 
            t.$subscribe = $(".tabs > a.subscribe", t.$elem), t.subscribe = new components.PopupSubscribe($(".component-popup-subscribe", t.$elem)), 
            t.$tabsButtons.click(function(e) {
                e.preventDefault(), t.switchTab($(this).data("tab"));
            }), t.$subscribe.click(function(e) {
                e.preventDefault(), t.subscribe.open();
            }), wdw.on("resize.Press", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        switchTab: function(e) {
            var t = this;
            t.$tabsContent.removeClass("active"), t.$tabsButtons.removeClass("active"), $(".tabs > a.btn-tab." + e, t.$elem).addClass("active"), 
            $(".tabs-content." + e, t.$elem).addClass("active");
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.subscribe.resize();
        }
    });
}(controllers), function(e) {
    "use strict";
    var t = 100;
    e.RevealController = Class.extend(Controller, {
        initialize: function(e) {
            if (this.parent(e), this.$items = e.find(".reveal-item"), this.$items.length) {
                this.firstAnimation = !0, this.topPositions = [], this.directions = [];
                for (var t = 0; t < this.$items.length; t++) this.directions[t] = "bottom";
                var i = this;
                wdw.on("resize.RevealController", function(e, t) {
                    i.resize(e, t);
                }).trigger("resize"), wdw.on("scroll.RevealController", function(e) {
                    i.scroll(e);
                }).trigger("scroll"), this.scroll(0), this.firstAnimation = !1;
            }
        },
        scroll: function(e) {
            for (var i = 0; i < this.topPositions.length; i++) this.mobile ? (this.$items.eq(i).removeClass("top-animation"), 
            this.$items.eq(i).removeClass("bottom-animation")) : (e + this.height > this.topPositions[i] + t && "bottom" === this.directions[i] && (this.directions[i] = "active", 
            this.firstAnimation ? this.removeBottomClass(i) : this.$items.eq(i).removeClass("bottom-animation")), 
            e > this.topPositions[i] + this.$items.eq(i).height() && "active" === this.directions[i] && (this.directions[i] = "top", 
            this.$items.eq(i).addClass("top-animation")), e < this.topPositions[i] + this.$items.eq(i).height() - t && "top" === this.directions[i] && (this.directions[i] = "active", 
            this.$items.eq(i).removeClass("top-animation")), e + this.height < this.topPositions[i] && "active" === this.directions[i] && (this.directions[i] = "bottom", 
            this.$items.eq(i).addClass("bottom-animation")));
        },
        removeBottomClass: function(e) {
            var t = this;
            setTimeout(function() {
                t.$items.eq(e).removeClass("bottom-animation");
            }, 200 * e);
        },
        resize: function(e, t) {
            e && (this.width = e), t && (this.height = t), this.mobile = e <= 740;
            for (var i = 0; i < this.$items.length; i++) this.topPositions[i] = this.$items.eq(i).offset().top;
        }
    });
}(controllers), function(e) {
    "use strict";
    e.ServiceAccessories = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$selects = $(".straps-filters .select", t.$elem), t.$items = $(".straps-item", t.$elem), 
            t.$itemButtons = $("a.btn-invisible-overlay", t.$items), t.$empty = $(".straps-empty", t.$elem), 
            t.types = [], t.selects = [];
            for (var i = 0; i < t.$selects.length; i++) t.types[i] = t.$selects.eq(i).data("type"), 
            t.selects[t.types[i]] = new components.Select($(".straps-filters .select-" + t.types[i], t.$elem)), 
            t.bindOnChange(t.selects[t.types[i]]);
            t.order = new components.PopupOrderAccessory($(".component-popup-order-accessory", t.$elem)), 
            t.filter(), t.$itemButtons.click(function(e) {
                e.preventDefault(), t.order.open($(this).parent().data("id"));
            }), wdw.on("resize.ServiceAccessories", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        bindOnChange: function(e) {
            var t = this;
            e.onChange = function() {
                t.filter();
            };
        },
        filter: function() {
            var e = this;
            if (e.$items.length) {
                for (var t = 0; t < e.$items.length; t++) {
                    for (var i = e.$items.eq(t), n = [], s = !0, a = 0; a < e.types.length; a++) {
                        var o = e.types[a];
                        if (n[o] = !1, i.data(o).length) for (var r = 0; r < i.data(o).length; r++) {
                            var l = i.data(o)[r].toString();
                            "null" !== e.selects[o].val() && e.selects[o].val() !== l || (n[o] = !0);
                        } else "null" === e.selects[o].val() && (n[o] = !0);
                    }
                    for (a = 0; a < e.types.length; a++) {
                        var c = e.types[a];
                        n[c] || (s = !1);
                    }
                    s ? i.show() : i.hide();
                }
                var h = !0;
                for (t = 0; t < e.$items.length; t++) "block" === e.$items.eq(t).css("display") && (h = !1);
                h ? e.$empty.show() : e.$empty.hide();
            } else e.$empty.show();
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t), i.order.resize();
        }
    });
}(controllers), function(e) {
    "use strict";
    e.ServiceFaq = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$headers = $(".faq-header", t.$elem), t.$content = $(".faq-content", t.$elem), 
            t.$text = $("p", t.$content), t.$headers.click(function(e) {
                e.preventDefault(), t.open($(this).parent().index());
            }), wdw.on("resize.ServiceFaq", function(e, i) {
                t.resize(e, i);
            }).trigger("resize");
        },
        open: function(e) {
            var t = this;
            t.$content.eq(e).hasClass("active") ? t.close() : (t.close(), t.$content.eq(e).addClass("active"), 
            t.$content.eq(e).height(t.$text.eq(e).height() + 40));
        },
        close: function() {
            var e = this;
            e.$content.height(0), e.$content.removeClass("active");
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t);
        }
    });
}(controllers), function(e) {
    "use strict";
    e.ServiceManuals = Class.extend(Controller, {
        initialize: function(e) {
            var t = this;
            t.parent(e), t.$elem = e, t.$manual = $(".manual", t.$elem), t.$nomanuals = $(".nomanuals", t.$elem), 
            t.$models = $(".select-model", t.$elem), t.selectModel = new components.Select(t.$models), 
            t.selectModel.onChange = function(e) {
                t.changeModel(e);
            }, t.models = $.map(t.$models.data("models"), function(e, t) {
                return {
                    id: t,
                    name: e
                };
            }), t.manuals = $.map(t.$models.data("manuals"), function(e) {
                return e;
            }), t.modelManuals = t.getModelManuals(), wdw.on("resize.ServiceManuals", function(e, i) {
                t.resize(e, i);
            }).trigger("resize"), t.initModels();
        },
        getModelManuals: function() {
            var e = [], t = [];
            return $.each(this.manuals, function(t, i) {
                e.push(i.models);
            }), e.length && (t = e.reduce(function(e, t) {
                return e.concat(t);
            })), $.map(t, function(e) {
                return e.toString();
            });
        },
        initModels: function() {
            var e = this;
            $(".model-option").each(function(t, i) {
                $.inArray($(i).attr("value"), e.modelManuals) === -1 && $(i).remove();
            });
        },
        changeModel: function(e) {
            var t = this;
            if (t.$manual.hide(), t.$nomanuals.hide(), "null" !== e) {
                for (var i = !1, n = 0; n < t.$manual.length; n++) for (var s = t.$manual.eq(n).data("models"), a = 0; a < s.length; a++) e.toString() === s[a].toString() && (t.$manual.eq(n).show(), 
                i = !0);
                i || t.$nomanuals.show();
            }
        },
        resize: function(e, t) {
            var i = this;
            (e || t) && (i.w = e, i.h = t);
        }
    });
}(controllers), function(e) {
    "use strict";
    e.Indicator = Class.extend({
        initialize: function(e) {
            var t = this, i = e.data();
            if (this.$elem = e, this.$parent = e.parent(), this._deg = null, this._data = null, 
            this._tween = null, this._isPanning = !1, this._pannable = i.pannable, this._aliases = i.aliases ? i.aliases.split(",") : [], 
            this.data = i, this.type = i.type, this.opposite = i.opposite, this.onPanEnd = null, 
            this.onPanMove = null, this.onPanStart = null, this._pannable) {
                var n = new Hammer(e.get(0));
                n.get("pan").set({
                    direction: Hammer.DIRECTION_ALL,
                    threshold: 0
                }), n.on("panstart", function(i) {
                    t._panEventIsAllowed(i) && (i.preventDefault(), app.onPanStart(e), t._isPanning = !0, 
                    utils.call(t.onPanStart, t, [ t ]));
                }), n.on("panmove", function(e) {
                    t._isPanning && (t._onPanMove(e.srcEvent), utils.call(t.onPanMove, t, [ t._deg ]));
                }), n.on("panend", function() {
                    t._isPanning && (app.onPanEnd(e), t._isPanning = !1, utils.call(t.onPanEnd, t, [ t._dataForDeg(t._deg) ]));
                }), e.addClass("u-is-pannable"), e.on("touchstart", function(e) {
                    e.preventDefault();
                });
            }
            TL.set(this.$elem, {
                z: .01
            }), this.setActive(this.type);
        },
        _dataForDeg: function() {
            return this;
        },
        _degForCoordinates: function(e, t) {
            var i = this.$parent.offset(), n = this.$parent.outerWidth() / 2, s = e - i.left, a = t - i.top, o = s <= n ? n - s : s - n, r = a <= n ? n - a : a - n, l = o / r, c = 180 * Math.atan(l) / Math.PI;
            return s >= n && a <= n ? c = c : s >= n && a >= n ? c = 180 - c : s <= n && a >= n ? c = 180 + c : s <= n && a <= n && (c = 360 - c), 
            Math.round(c);
        },
        _degForData: function() {
            return this;
        },
        _editDirectionBasedOnOpposite: function(e) {
            return this.opposite && "cw" === e ? "ccw" : e;
        },
        _onPanMove: function(e) {
            this.rotate(this._degForCoordinates(e.pageX, e.pageY));
        },
        _panEventIsAllowed: function(e) {
            return $(e.target).data("type") === this.type;
        },
        rotate: function(e) {
            this._deg = e, TL.set(this.$elem, {
                rotation: e
            });
        },
        setActive: function(e) {
            this.$elem.toggleClass("is-active", e === this.type || $.inArray(e, this._aliases) !== -1 && !this.opposite);
        },
        setData: function(e, t, i) {
            var n = this._degForData(e, t);
            this._data = e, this._tween = TL.to(this.$elem, 1, {
                directionalRotation: (this.opposite ? -n : n) + "_" + this._editDirectionBasedOnOpposite(i),
                ease: t ? Power4.easeInOut : Linear.easeNone
            });
        },
        stop: function() {
            this._tween && this._tween.kill();
        }
    });
}(window), function(e) {
    "use strict";
    e.Temp = Class.extend(Indicator, {
        initialize: function(e) {
            this.parent(e), this._offset = this.data.offset;
        },
        _degForData: function(e) {
            return Math.round((e.temp + 5) / 60 * 360) + this._offset;
        },
        _dataForDeg: function(e) {
            var t = this._offset;
            return e = e < t ? 360 - t + e : e - t, {
                temp: Math.floor(e / 360 * 60 - 5)
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.IndicatorTime = Class.extend(Indicator, {
        initialize: function(e) {
            this.parent(e), this._child = null, this._periods = {
                date: {
                    amount: 31,
                    deg: 360 / 31
                },
                day: {
                    amount: 7,
                    deg: 360 / 7
                },
                hour: {
                    amount: 24,
                    deg: 30
                },
                minute: {
                    amount: 60,
                    deg: 6
                },
                second: {
                    amount: 60,
                    deg: 6
                }
            };
        },
        _degForData: function(e, t) {
            var i = t ? e.time : e.time.clone().add(1, "s");
            return this._degForTime(i);
        },
        _degForTime: function() {
            return this;
        },
        _timeValueChildForDeg: function(e) {
            var t = this._periods[this.type], i = Math.floor(e / t.deg) * t.deg, n = e - i, s = n / t.deg * 100;
            return Math.floor(this._child.amount / 100 * s);
        }
    });
}(window), function(e) {
    "use strict";
    e.Date = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e), this._child = this._periods.day;
        },
        _degForTime: function(e) {
            return Math.round(e.date() / 31 * 360) + 6;
        },
        _dataForDeg: function(e) {
            return e -= 6, {
                time: this._data.time.clone().date(Math.floor(e / 360 * 31)).isoWeekday(this._timeValueChildForDeg(e))
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Day = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e), this._child = this._periods.hour;
        },
        _degForTime: function(e) {
            var t = e.isoWeekday() / 7 * 360, i = this._periods.day.deg - this._periods.day.deg / 100 * e.hour() / 24 * 100;
            return Math.round(t - i);
        },
        _dataForDeg: function(e) {
            return {
                time: this._data.time.clone().isoWeekday(Math.ceil(e / 360 * 7)).hour(this._timeValueChildForDeg(e))
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Hour = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e), this._child = this._periods.minute;
        },
        _degForTime: function(e) {
            var t = e.hour() / 24 * 720, i = this._periods.hour.deg / 100 * e.minute() / 60 * 100;
            return Math.round(t + i);
        },
        _dataForDeg: function(e) {
            return {
                time: this._data.time.clone().hour(Math.floor(e / 720 * 24) + (this._data.time.hour() > 12 ? 12 : 0)).minute(this._timeValueChildForDeg(e))
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Minute = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e), this._child = this._periods.second;
        },
        _degForTime: function(e) {
            var t = e.minute() / 60 * 360, i = this._periods.second.deg / 100 * e.second() / 60 * 100;
            return Math.round(t + i);
        },
        _dataForDeg: function(e) {
            return {
                time: this._data.time.clone().minute(Math.floor(e / 360 * 60)).second(this._timeValueChildForDeg(e))
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Second = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e);
        },
        _degForTime: function(e) {
            return Math.round(e.second() / 60 * 360);
        },
        _dataForDeg: function(e) {
            return {
                time: this._data.time.clone().second(Math.floor(e / 360 * 60))
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.SecondType3 = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e);
        },
        _degForTime: function(e) {
            return (60 * e.minute() + e.second()) % 360;
        },
        _dataForDeg: function(e) {
            var t = this._data.time.clone(), i = 60 * t.minute(), n = i - i % 360 + e, s = n % 60;
            return t.minute((n - s) / 60).second(s), {
                time: t
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.SecondType5 = Class.extend(IndicatorTime, {
        initialize: function(e) {
            this.parent(e);
        },
        _degForTime: function(e) {
            return (60 * e.minute() + e.second()) % 90 * 4;
        },
        _dataForDeg: function(e) {
            var t = this._data.time.clone(), i = 60 * t.minute(), n = i - i % 90 + Math.round(e / 4), s = n % 60;
            return t.minute((n - s) / 60).second(s), {
                time: t
            };
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Zone = Class.extend(Indicator, {
        _degForData: function(e) {
            var t = e.zoneOption;
            return t ? t.deg : 0;
        }
    });
}(indicators), function(e) {
    "use strict";
    e.Modifier = Class.extend({
        initialize: function(e) {
            var t = this;
            this.$elem = e, this._comp = {}, this._manipulations = {
                ampm: function(e) {
                    return e.time.hour() < 12 ? "am" : "pm";
                },
                date: function(e) {
                    return e.time.date();
                },
                day: function(e) {
                    return e.time.isoWeekday();
                },
                hour: function(e) {
                    return this._convertToAmPm(e.time.hour());
                },
                minute: function(e) {
                    return e.time.minute();
                },
                second: function(e) {
                    return e.time.second();
                },
                temp: function(e) {
                    return e.temp;
                }
            }, this.onBlur = null, this.onFocus = null, $("input", e).each(function() {
                var e = new components.InputNumber($(this));
                t._comp[e.data.type] = e, e.onFocus = function() {
                    t._onFocus(this);
                }, e.onBlur = function() {
                    t._onBlur(this);
                };
            }), $(".select", e).each(function() {
                var e = new components.Select($(this));
                t._comp[e.data.type] = e, e.onFocus = function() {
                    t._onFocus(this);
                }, e.onChange = function() {
                    this.trigger("blur");
                }, e.onBlur = function() {
                    t._onBlur(this);
                };
            });
        },
        _convertFromAmPm: function(e, t) {
            var i;
            return i = "am" === t ? e < 12 ? e : 0 : e < 12 ? e + 12 : e;
        },
        _convertToAmPm: function(e) {
            var t;
            return t = e < 12 ? e ? e : 12 : e > 12 ? e - 12 : e;
        },
        _onBlur: function(e) {
            var t = this._comp, i = t.hour.val(), n = {
                time: moment({
                    hour: t.ampm ? this._convertFromAmPm(i, t.ampm.val()) : i,
                    minute: t.minute.val(),
                    second: t.second ? t.second.val() : 0
                })
            };
            t.day && n.time.isoWeekday(t.day.val()), t.date && "date" === e.data.type && n.time.date(t.date.val()), 
            t.temp && (n.temp = t.temp.val()), utils.call(this.onBlur, this, [ n ]);
        },
        _onFocus: function(e) {
            utils.call(this.onFocus, this, [ e ]);
        },
        setData: function(e) {
            var t = this, i = this._manipulations;
            $.each(this._comp, function(n) {
                this.val(utils.call(i[n], t, [ e ]));
            });
        },
        setType: function(e) {
            $.each(this._comp, function(t) {
                this.$elem.toggleClass("is-active", t === e);
            });
        }
    });
}(window), function(e) {
    "use strict";
    e.Simulator = Class.extend(Component, {
        initialize: function(e, t) {
            this.parent(e, t);
            var i = this;
            this.zoneOption = {};
            this.$autocomplete = $(".autocomplete", e), 
            this.$type = $(".type", e), this.$btnNow = $(".btn-now", e), this.$btnType = $(".btn-type", e), 
            this._auto = !0, this._data = t ? t.data : null, this._interval = null, this._types = {
                ampm: "AM/PM",
                date: "Date",
                day: "Days",
                hour: "Hours",
                minute: "Minutes",
                second: "Seconds",
                temp: "Temperature",
                mechanical: "0",
                timezone1: "270",
                timezone2: "90"
            }, 
            this.beerOClockIsEnabled = !1, this.modifier = new Modifier($(".modifier", e)), 
            this.watchNormal = new Watch($(".watch-normal", e)), 
            this.watchRessence = new Watch($(".watch-ressence", e)), 
            this.slider = new components.Slider($(".slider", e), {
                min: -5,
                max: 55,
                scaleStep: 10,
                scaleOffset: 5
            }), this.$btnNow.on("click", function() {
                i.now();
            }), this.$btnType.on("click", function() {
                i.setType($(this).data("type"));
            }), this.modifier.onFocus = this.watchNormal.onPanStart = this.watchRessence.onPanStart = this.slider.onPanStart = function(e) {
                i.stop(), i.setType(e.data.type);
            }, this.modifier.onBlur = this.watchNormal.onPanEnd = this.watchRessence.onPanEnd = function(e) {
                i.setData(e, !0), i.play();

                if(i.zoneOptions != undefined){
                    if(e._deg === 0 || e._deg < 50 || e._deg >=320){
                        var mechanical = "mechanical";
                        i.setActiveZoneOption(mechanical);  
                    }else if(e._deg == 50 || e._deg <= 130){
                        var timezone2 = "timezone2";
                        i.setActiveZoneOption(timezone2);
                    }else if(e._deg < 320 && e._deg > 230 ){
                        var timezone1 = "timezone1";
                        i.setActiveZoneOption(timezone1);
                    }else if( e._deg > 130 || e._deg < 230){
                        var mechanical = "mechanical";
                        i.setActiveZoneOption(mechanical);
                    }    
                }
            }, this.slider.onPanEnd = function(e) {
                i.setData({
                    temp: e
                }, !0), i.play();
            }, this.slider.on("tap", function(e) {
                i.stop(), i.setType(this.data.type), i.setData({
                    temp: e
                }, !0), i.play();
            }), this.setData({
                temp: 20,
                time: moment()
            }, !0), this.setType(this.$btnType.first().data("type")), this._auto && this.play();
        },
        _tick: function() {
            this.setData({
                time: this._data.time.clone().add(1, "s")
            });
        },
        beerOClock: function() {
            if (this.beerOClockIsEnabled) {
                var e = this._data.time;
                5 === e.isoWeekday() && 17 === e.hour() && (alert("It's Beer O'Clock!"), this.beerOClockIsEnabled = !1);
            }
        },
        now: function() {
            this.stop(), this.setData({
                time: moment()
            }, !0), this.play();
        },
        play: function() {
            this._interval = utils.setInterval(this, 1e3, this._tick);
        },
        setType: function(e) {
            this.modifier.setType(e), this.watchNormal.setType(e), this.watchRessence.setType(e), 
            this.$type.text(this._types[e]), this.slider.$elem.toggleClass("is-active", "temp" === e), 
            this.$btnType.removeClass("is-active").filter('[data-type="' + e + '"]').addClass("is-active");
        },
        setData: function(e, t) {
            var i = this._data ? "short" : "cw";
            e = $.extend(this._data, e), this._data = e, this.slider.val(e.temp), this.modifier.setData(e), 
            this.watchNormal.setData(e, t, i), this.watchRessence.setData(e, t, i), this.beerOClock();
        },
        stop: function() {
            this.watchNormal.stop(), this.watchRessence.stop(), clearInterval(this._interval);
        },
    });
}(components), function(e) {
    "use strict";
    e.SimulatorType2 = Class.extend(e.Simulator, {
        initialize: function(t, i) {
            var n = this;
            this.$toggleBtn = $(".toggle-btn", t), this.activeZoneOption = null, this.zoneOptions = {}, 
            $(".option", t).each(function() {
                var t = new e.ZoneOption($(this));
                t.on("select", function() {
                    n.setActiveZoneOption(t.key);
                }), t.on("set-time", function() {
                    n.setNewData({
                        time: t.time
                    });
                }), n.zoneOptions[t.key] = t;
            }), this.$toggleBtn.on("click", function() {
                n.setActiveZoneOption($(this).data("key"));
            }), this.parent(t, i), this.setActiveZoneOption("mechanical");
        },
        setActiveZoneOption: function(e) {
            var t = this.zoneOptions[e], i = this.activeZoneOption;
            t !== i && (i && (i.toggleActive(!1), this.setNewData({
                time: t.time,
                zoneOption: t
            })), $.each(this.watchRessence._indicators, function(e, n) {
                n._pannable && (i && n.$elem.removeClass("indicator-" + i.key), n.$elem.addClass("indicator-" + t.key));
            }), this.$toggleBtn.removeClass("is-active").filter('[data-key="' + e + '"]').addClass("is-active"), 
            t.toggleActive(!0), this.activeZoneOption = t);
        },
        setData: function(e, t, i) {
            var n = this.activeZoneOption;
            t ? n ? i || (n.setTimeToManual(), n.setTime(e.time)) : $.each(this.zoneOptions, function(t, i) {
                i.setTime(e.time);
            }) : $.each(this.zoneOptions, function(t, i) {
                i === n ? i.setTime(e.time) : i.incrementTime();
            }), this.parent(e, t);
        },
        setNewData: function(e) {
            this.stop(), this.setData(e, !0, !0), this.play();
        },

    });
}(components), function(e) {
    "use strict";
    e.Watch = Class.extend({
        initialize: function(e) {
            var t = this;
            this.$elem = e, this.$label = $("[data-format]", e), this._data = null, this._indicators = [], 
            this.onPanEnd = null, this.onPanStart = null, $(".indicator", e).each(function() {
                var e = $(this), i = utils.classify(e.data("class") || e.data("type"));
                if (i) {
                    var n = new indicators[i](e);
                    t._indicators.push(n), n.onPanStart = function(e) {
                        utils.call(t.onPanStart, t, [ e ]);
                    }, n.onPanMove = function(e) {
                        var i = this.type;
                        $.each(t._indicators, function() {
                            this.type === i && this.opposite && this.rotate(-e);
                        });
                    }, n.onPanEnd = function(e) {
                        utils.call(t.onPanEnd, t, [ e ]);
                    };
                }
            });
        },
        setData: function(e, t, i) {
            this._data = e, $.each(this._indicators, function() {
                this.setData(e, t, i);
            }), this.$label.each(function() {
                var t = $(this);
                t.text(e.time.format(t.data("format")));
            });
        },
        setType: function(e) {
            $.each(this._indicators, function() {
                this.setActive(e);
            }), this.$label.removeClass("is-active").filter('[data-type="' + e + '"]').addClass("is-active");
        },
        stop: function() {
            $.each(this._indicators, function() {
                this.stop();
            });
        }
    });
}(window), function(e) {
    "use strict";
    function t(e) {
        var t = e.replace(/_/g, " ").split("/"), i = t[0];
        return t[1] && (i = t[1] + ", " + i), {
            label: i,
            sortBy: i.toLowerCase(),
            value: e
        };
    }
    function i(e) {
        return {
            data: moment.tz.names().map(function(e) {
                return t(e);
            }),
            getValue: "label",
            list: {
                match: {
                    enabled: !0,
                    method: function(e, t) {
                        return e.substr(0, t.length) === t;
                    }
                },
                onChooseEvent: e,
                sort: {
                    enabled: !0,
                    method: function(e, t) {
                        return e.sortBy < t.sortBy ? -1 : e.sortBy > t.sortBy ? 1 : 0;
                    }
                }
            }
        };
    }
    e.ZoneOption = Class.extend(Abstract, {
        initialize: function(e) {
            this.parent();
            var n = this, s = e.data();
            this.$elem = e, 
            this.$autocomplete = $(".autocomplete", e), 
            this.$clockBtn = $(".clock-btn", e), 
            this.$clockTime = $(".clock-time", e), 
            this.$clockTimezone = $(".clock-timezone", e), 
            this._eventListeners = {
                select: [],
                "set-time": []
            }, 

            this.deg = s.deg, this.key = s.key, this.time = null, this.timezone = t(s.timezone || moment.tz.guess()), 
            this.$elem.addClass("option-" + this.key), 
            this.$autocomplete.length && (this.$autocomplete.val(this.timezone.label), 
            
            this.$autocomplete.easyAutocomplete(i(function() {
                n.setTimezone(n.$autocomplete.getSelectedItemData());
            })), 
            this.$autocomplete.on("focus", function() {
                n.$autocomplete.val("");
            }), 
            this.$autocomplete.on("blur", function() {
                n.$autocomplete.getSelectedItemData() === -1 && n.$autocomplete.val(n.timezone.label);
            })), 
            this.$elem.on("click", function() {
                n._callEventListeners("select");
            }), 
            this.$clockBtn.on("click", function() {
                n.setTimeToLocal();
            });
        },
        applyTimezone: function(e) {
            return this.timezone && e.tz(this.timezone.value), e;
        },
        incrementTime: function() {
            this.setTime(this.time.add(1, "second"));
        },
        setTime: function(e) {
            if(e){
            var t = e.clone();
            
            this.time = this.applyTimezone(t), this.$clockTime.html(this.time.format("HH:mm:ss")), 
            this.$clockTimezone.html(this.time.format("A [GMT] Z"));
            }
        },
        setTimeToManual: function() {
            "mechanical" !== this.key && (this.timezone = null, this.$autocomplete.prop("disabled", !0), 
            this.$autocomplete.val(trans.manual), this.$clockTimezone.hide(), this.$clockBtn.show());
        },
        setTimeToLocal: function() {
            this.timezone = t(moment.tz.guess()), this.$autocomplete.prop("disabled", !1), this.$autocomplete.val(this.timezone.label), 
            this.$clockTimezone.show(), this.$clockBtn.hide(), this.setTime(moment()), this._callEventListeners("set-time");
        },
        setTimezone: function(e) {
            e.value !== this.timezone.value && (this.timezone = e, this.setTime(moment()), this._callEventListeners("set-time"));
        },
        toggleActive: function(e) {
            this.$elem.toggleClass("is-active", e);
        }
    });
}(components), function(e) {
    "use strict";
    e.doc = new Doc(), e.wdw = new Wdw(), e.app = new App($(".app")), e.onload = function() {
        e.app.activate();
    };
}(window);